import React from 'react';
import PropTypes from 'prop-types';

import useAccountRouter from 'Components/Account/useAccountRouter';
import NotInteractiveVehicleCard from 'Components/shared/VehicleCards/NotInteractiveVehicleCard/NotInteractiveVehicleCard';
import VehicleCard from 'Components/shared/VehicleCards/VehicleCard/VehicleCard';
import { VehicleContextProvider } from 'Context/VehicleContext';
import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import { triggerAccountVehicleDetailsClickedEvent } from 'Services/analytics/events';
import proPropTypes from 'Utilities/proPropTypes';

import AccountVehicleCardLoadingView from './AccountVehicleCardLoadingView/AccountVehicleCardLoadingView';
import AccountVehicleCardView from './AccountVehicleCardView/AccountVehicleCardView';

const AccountVehicleCard = (props) => {
	const { permits, triggerSuccessToast, vehicle } = props;
	// cards are not clickable for cancelled purchases as page would be resolved as not found vehicle
	const clickable = !permits.isPurchaseCancelledPage();
	const { slug } = useAccountRouter();

	const Card = clickable ? VehicleCard : NotInteractiveVehicleCard;

	const onClick = () => {
		triggerAccountVehicleDetailsClickedEvent({ id: vehicle.id, slug });
	};

	const cardProps = {
		...props,
		...(clickable ? { onClick } : {}),
	};

	return (
		<VehicleContextProvider vehicle={vehicle}>
			<Card {...cardProps} loadingView={<AccountVehicleCardLoadingView />}>
				<AccountVehicleCardView triggerSuccessToast={triggerSuccessToast} vehicle={vehicle} />
			</Card>
		</VehicleContextProvider>
	);
};

AccountVehicleCard.defaultProps = {
	children: null,
	className: '',
	loading: false,
	loadingView: null,
	vehicle: {},
};

AccountVehicleCard.propTypes = {
	children: PropTypes.node,
	className: proPropTypes.className,
	loading: PropTypes.bool,
	loadingView: PropTypes.node,
	permits: proPropTypes.accountPermitsChecker.isRequired,
	vehicle: proPropTypes.accountVehicle,
};

AccountVehicleCard.displayName = 'AccountVehicleCard';

export default WithAccountPermitsChecker()(AccountVehicleCard);
